import { useHTTP } from '@/plugins/http'
import User from '@/models/user/User'
import { useContext } from '@/plugins/context'
import { Machine } from '@/models/company/Machine'
import Location from '@/models/company/Location'

// interface AuthState {
//   user?: User;
//   expires?: Date;
// }

const userEndpoints = {
  login: `${User.ENDPOINT}/login`,
  logout: `${User.ENDPOINT}/logout`,
  isLoggedIn: `${User.ENDPOINT}/is-logged-in`,
  storeSwitch: '/user/store-switch'
}

const USER_LOCAL_STORAGE_KEY = 'user'
const ACCESST_TOKEN_LOCAL_STORAGE_KEY = 'token'
const PERMISSIONS_LOCAL_STORAGE_KEY = 'permissions'

export const useAuth = () => {
  const { post, get } = useHTTP()
  const ctx = useContext()

  const userLogin = async (credentials: { username: string; password: string }): Promise<User> => {
    const resp = await post<User>(
      `${userEndpoints.login}?machine_guid=${ctx.machineGUID}`,
      credentials
    )
    const user = User.from(resp)
    ctx.setUser(User.from(user))
    localStorage.setItem(USER_LOCAL_STORAGE_KEY, JSON.stringify(user))
    localStorage.setItem(ACCESST_TOKEN_LOCAL_STORAGE_KEY, user.accessToken)

    return user
  }

  const getSwitchableMachines = async (): Promise<Machine[]> => {
    const resp = await get<Machine[]>(userEndpoints.storeSwitch)
    return (resp || []).map((m) => Machine.from(m))
  }

  const switchStore = async (machineID: string): Promise<Machine> => {
    const resp = await post<{ user: User; machine: Machine }>(userEndpoints.storeSwitch, { machineID })
    const user = User.from(resp.user)
    const machine = Machine.from(resp.machine)

    ctx.setUser(user)
    localStorage.setItem(USER_LOCAL_STORAGE_KEY, JSON.stringify(user))
    localStorage.setItem(ACCESST_TOKEN_LOCAL_STORAGE_KEY, user.accessToken)

    ctx.setMachineGUID(machine.machineGUID)
    ctx.setMachine(machine)
    ctx.setRegister(machine.register)
    ctx.setLocation(Location.from(machine.location))

    return machine
  }

  const resetAuthState = () => {
    ctx.setUser(new User())
    localStorage.removeItem(USER_LOCAL_STORAGE_KEY)
    localStorage.removeItem(ACCESST_TOKEN_LOCAL_STORAGE_KEY)
    localStorage.removeItem(PERMISSIONS_LOCAL_STORAGE_KEY)
  }

  const userLogout = async () => {
    await post(userEndpoints.logout)
    resetAuthState()
    location.reload()
  }

  const loggedIn = async (): Promise<boolean> => {
    if (!ctx.currentUser.accessToken) return false
    return (
      get(userEndpoints.isLoggedIn)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then((_) => true)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .catch((_) => false)
    )
  }

  return {
    userLogin,
    userLogout,
    loggedIn,
    resetAuthState,
    getSwitchableMachines,
    switchStore
  }
}
